import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetchCandidatePrivacySettings,
  updateCandidatePrivacySettings,
  type CandidatePrivacySettings,
} from '../api/candidateSettings';

const PRIVACY_QUERY_KEY = ['candidate-privacy'];

export function useCandidatePrivacySettings() {
  return useQuery<CandidatePrivacySettings>({
    queryKey: PRIVACY_QUERY_KEY,
    queryFn: fetchCandidatePrivacySettings,
    staleTime: 1000 * 60,
  });
}

type MutationContext = { previous?: CandidatePrivacySettings };

export function useUpdateCandidatePrivacySettings() {
  const queryClient = useQueryClient();
  return useMutation<CandidatePrivacySettings, Error, CandidatePrivacySettings, MutationContext>({
    mutationFn: updateCandidatePrivacySettings,
    onMutate: async (nextSettings) => {
      await queryClient.cancelQueries({ queryKey: PRIVACY_QUERY_KEY });
      const previous = queryClient.getQueryData<CandidatePrivacySettings>(PRIVACY_QUERY_KEY);
      queryClient.setQueryData<CandidatePrivacySettings>(PRIVACY_QUERY_KEY, nextSettings);
      return { previous };
    },
    onError: (_error, _variables, context) => {
      if (context?.previous) {
        queryClient.setQueryData<CandidatePrivacySettings>(PRIVACY_QUERY_KEY, context.previous);
      }
    },
    onSuccess: (data) => {
      queryClient.setQueryData<CandidatePrivacySettings>(PRIVACY_QUERY_KEY, data);
    },
  });
}
